'use strict';

module.exports = function (ngModule) {
    ngModule.controller('newDnsQueriesController', require('./new_dns_queries'));
    ngModule.controller('newFtpRemoteController', require('./new_ftp_remote'));
    ngModule.controller('newHttpDomainsController', require('./new_http_domains'));
    ngModule.controller('newRemoteController', require('./new_remote'));
    // ngModule.controller('newLocalIpController', require('./new_local_ip'));
    // ngModule.controller('newLocalMacController', require('./new_local_mac'));
    ngModule.controller('newSshRemoteController', require('./new_ssh_remote'));
    ngModule.controller('newSslHostsController', require('./new_ssl_hosts'));
}



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/anomalies/index.js
 **/